var map = {
	"./Close_Icon.svg": "oLZs",
	"./FavIcon.png": "E2pj",
	"./b9.png": "jx1E",
	"./b9.svg": "hEMB",
	"./bg1.png": "9TAr",
	"./bg2.png": "Wx8z",
	"./bg3.png": "UAoe",
	"./brinco.png": "MH7Q",
	"./brinco.svg": "yBLg",
	"./compare icon.png": "YsnF",
	"./icon-star.png": "427k",
	"./iconarrow.png": "64+y",
	"./live_icon.png": "38Nf",
	"./loto5.png": "NFPc",
	"./loto5.svg": "Yq8h",
	"./loto5Bg.svg": "rpQk",
	"./loto_plus.png": "S/Zw",
	"./loto_plus.svg": "CJ+S",
	"./previous icon.png": "iQT7",
	"./quini.png": "g/UG",
	"./quini.svg": "331+",
	"./quini6.png": "Fz63",
	"./quini6.svg": "Y2ca",
	"./quiniela.png": "5D1g",
	"./quiniela.svg": "ABb6",
	"./quiniela_poceada.png": "queF",
	"./quiniela_poceada.svg": "ky9Y",
	"./quinielas-min.png": "WwcS",
	"./quinielas.png": "pzko",
	"./quinielashoylogo-min.png": "b/zs",
	"./quinielashoylogo.png": "3Z8K",
	"./rekino.png": "FjQI",
	"./rekino.svg": "Q/7N",
	"./remindmeicon-min.png": "6SXW",
	"./remindmeicon.png": "jluS",
	"./share icon-min.png": "JPe+",
	"./share icon.png": "z1QC",
	"./telekino-min.png": "ZKdy",
	"./telekino.png": "F0NL",
	"./telekino.svg": "UMtt",
	"./telekinoBg.svg": "EDcZ",
	"./totobingo-min.png": "xIK9",
	"./totobingo.png": "wUMv",
	"./updateicon-min.png": "y/gf",
	"./updateicon.png": "CuUT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";